module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/工作站图片日文.712cd879.png";